export const readBrowserCookies = (): string[][] =>
  document.cookie.split(';').map((value) => value.trim().split('='))

export const mapBrowserCookies = () =>
  readBrowserCookies().reduce(
    (acc, [name, value]) => ({ ...acc, [name]: value }),
    {}
  )
